import React from 'react';
import { useState as UseState } from "react";
import Grid from '@mui/material/Grid';
import { ThemeProvider } from '@mui/material/styles';
import { Button, Box, Input, Container, Typography } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import filesService from "../../../services/files";
import constants from '../../../utils/constants';
import scheduledFileService from '../../../services/scheduledFile';
import AuthService from "../../../services/security/auth.service";
import MenuApp from '../../../components/Menu';

const index = () => {

    const [file, setFile] = UseState(null);
    const [openSnackbar, setOpenSnackbar] = UseState(false);
    const [loading, setLoading] = UseState(false);

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const handleChange = (e) => {
        console.log(e.target.files[0])
        setFile(e.target.files[0]);
    };

    const uploadFile = () => {
        const user = AuthService.getCurrentUser();
        let fileDoc = 'cpdregoperac';
        if (user) {
            console.log(file)
            if (file) {
                const formData = new FormData();
                console.log(file.name)
                formData.append('attachments', file);
                formData.append('bucket', constants.CLIENT_STORAGE);
                formData.append('folder', `${user.data.instance}/${fileDoc}`);
                setLoading(true);
                filesService.saveFiles(formData).then((response) => {
                    console.log(response.data);
                    for (let r = 0; r < response.data.length; r++) {

                        let request = {
                            name: response.data[r],
                            executes: {
                                fechaHora: new Date(),
                                estado: "En proceso"
                            }
                        }
                        console.log('request' + request)
                        scheduledFileService.save(constants.CLIENT, user.data.instance, fileDoc, request).then((response) => {
                            console.log(response);
                            setOpenSnackbar(true);
                            setLoading(false);
                        }).catch((error) => {
                            console.log(error);
                            setLoading(false);
                        });
                    }
                }).catch((error) => {
                    console.log(error);
                    setLoading(false);
                });
            }
        }
    }

    return (
        <div>
            <MenuApp />
            <div>
                <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
                    Archivo CPD-REGOPERAC
                </Typography>


                <div style={{ display: 'inline-block', margin: '0 0.2px' }}>

                    <Box sx={{ width: '100%' }}>
                        <Typography
                            //style={{ fontSize: '1.2rem' }}
                            variant={'h4'}
                            gutterBottom
                        >
                            Archivo CPD-REGOPERAC
                        </Typography>
                    </Box>
                    <Snackbar
                        open={openSnackbar}
                        autoHideDuration={6000}
                        onClose={handleSnackbarClose}
                        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    >
                        <MuiAlert
                            elevation={6}
                            variant="filled"
                            onClose={handleSnackbarClose}
                            severity="success"
                        >
                            Proceso finalizado correctamente
                        </MuiAlert>
                    </Snackbar>
                    <Grid container xs={12} item>
                        <Grid item>
                            <ThemeProvider theme={constants.CUSTOM_MUI_TEXT_FIELD_THEME}>
                                <Container>
                                    <Input
                                        type="file"
                                        inputProps={{ accept: '.csv,.txt', /*style: { fontSize: "0.8rem" }*/ }}
                                        variant="outlined"
                                        onChange={handleChange}
                                    />
                                    {loading && <CircularProgress />}
                                    {!loading &&
                                        <Button
                                            variant='outlined'
                                            onClick={uploadFile}>Procesar Archivo
                                        </Button>
                                    }
                                </Container>
                            </ThemeProvider>
                        </Grid>
                    </Grid>

                </div>
            </div>
        </div>
    )

}

export default index;